export const OPEN_INTERNAL_BANNERS_EDIT = 'OPEN_INTERNAL_BANNERS_EDIT';
export type OPEN_INTERNAL_BANNERS_EDIT = typeof OPEN_INTERNAL_BANNERS_EDIT;

export interface OpenInternalBannersEdit {
    type: OPEN_INTERNAL_BANNERS_EDIT;
}

export function openInternalBannersEditAction(): OpenInternalBannersEdit {
    return {
        type: OPEN_INTERNAL_BANNERS_EDIT
    };
}
